import React from 'react';

import { Stack, Divider, Group, Text } from '@mantine/core';
import { AthleteAppointmentRosterRow } from 'types';
import { LastCreditAlertContent } from 'utils/last-credit-alert';

import ReservedAndCheckedInAthlete from './components/ReservedAndCheckedInAthlete';

interface IReservedAndCheckedInAthletesProps {
  athleteAppointments: AthleteAppointmentRosterRow[];
  handleCloseDrawer: () => void;
  permission?: boolean;
  setLastCreditAlert: React.Dispatch<React.SetStateAction<LastCreditAlertContent | null>>;
}

const ReservedAndCheckedInAthletes = ({
  athleteAppointments,
  handleCloseDrawer,
  permission = true,
  setLastCreditAlert,
}: IReservedAndCheckedInAthletesProps): JSX.Element => {
  if (athleteAppointments.length) {
    return (
      <Stack spacing={0}>
        {athleteAppointments.map((aa, index) => {
          return (
            <ReservedAndCheckedInAthlete
              athleteAppointment={aa}
              index={index}
              key={index}
              handleCloseDrawer={handleCloseDrawer}
              athleteAppointmentsLength={athleteAppointments.length}
              permission={permission}
              setLastCreditAlert={setLastCreditAlert}
            />
          );
        })}
        <Divider />
      </Stack>
    );
  }
  return (
    <Group position='center'>
      <Text color='dimmed'>No athletes to display</Text>
    </Group>
  );
};

export default ReservedAndCheckedInAthletes;
